//translations
import localisation from "../services/localisation";
import IL from "../interfaces/localisation";
import routeListen from "../services/routeListen";
import tokenStorageService from "../services/TokenStorageService";

export function parseLocalStorageJwt(token: string) {
    try {
        const tokenPart = token.split('.')[1];
        const decodedPayload =  JSON.parse(atob(tokenPart));
        return decodedPayload;
    } catch (error) {
        console.error(localisation.getLocalString(IL["Errors.Error"]),error);
        return null;
    }
}

export function isTokenExpired(token?: string | null) {
  if (token) {
    const decodedToken = parseLocalStorageJwt(token);
    if (!decodedToken) {
      return false;
    }
    if (decodedToken?.exp && decodedToken?.exp * 1000 <= Date.now().valueOf()) {
      return true;
    }
    return false;
  }
  return false;
}

export function getAuthAppURL(featureName?:string): string {
  const environment = (localStorage.getItem('environmentName') as string);
  const shortcode = routeListen.shortName();
    switch(environment) {
        case 'QA':
            return `https://${shortcode}.auth.tab-qa.com/`;
        case 'Production':
            return convertTheAppbuilderToThriveApp(`https://${shortcode}.auth.theappbuilder.com/`);
        case 'Local':
            return `https://${shortcode}.auth.tab-dev.com/`;
        case 'Development':
            return `https://${shortcode}.auth.${featureName ?? process.env.FEATURENAME}.tab-feature.com/`
        case 'Dev':
            return `https://${shortcode}.auth.tab-dev.com/`
        default:
            let url = '$__{DevApiUrl}__$'.replace('/api.', `/${shortcode}.auth.`);
            
            return convertTheAppbuilderToThriveApp(url)
    }
}

export function convertTheAppbuilderToThriveApp(url: string) {
    if(url.includes('theappbuilder.com')) {
        url = url.replace('theappbuilder.com', 'thrive.app')
    }
    return url;
}


export function cleanupLocalStorageAuthValues(){
  tokenStorageService.removeItem('orgShortName');
  tokenStorageService.removeItem('token');
  tokenStorageService.removeItem('userId');
  tokenStorageService.removeItem('tokenExpired');
}